import React, { useState } from "react";


import { Icon } from "components/Icon";

import { CustomTextarea } from "components/Form/CustomTextarea";
import {
    StyledButton,
    StyledContainerColumn,
    StyledContainerRow,
    StyledFormStart,
    StyledLabel,
} from "./TrunkFormRefactored.styles";

import { Form, InputNumber, SelectPicker } from "rsuite";
import Whisper from "components/Whisper";

const MoreOptionsFormSection = ({ service, error, model, setError, disabled, setMoreData, initialValues, onPostbackTest, parametersInfo, isDefault }) => {

    const payoutModelList = [{
        name: service ? "Price per minute" : "Price per message",
        value: 1
    }, {
        name: "Revenue share",
        value: 2
    }];

    const postbackMethodData = [
        {
            name: "POST",
            value: "POST"
        },
        {
            name: "GET",
            value: "GET"
        }
    ];

    const defaultFormValue = {
        ...(!service ? { postback_method: "GET" } : {}),
        ...initialValues
    };

    const [formData, setFormData] = useState(defaultFormValue);
    const [showRevenue, setShowRevenue] = useState(initialValues?.payout_model === 2);
    const [payoutModel, setPayoutModel] = useState(initialValues.payout_model || 1);

    const errorObject = error["moreOptionsError"] || {};

    return (
        <Form
            model={model}
            layout="inline"
            formDefaultValue={defaultFormValue}
            formValue={formData}
            onChange={(value) => {
                const formValue = { ...defaultFormValue, ...value };

                const revenueIsNull = formValue?.payout_model === 2 && !formValue?.revenue_percent;
                const formCheck = model.check(value);
                const errors = {};

                if (revenueIsNull) {
                    errors.revenue_percent = "Required";
                }

                const formErrors = Object.keys(formCheck).reduce((data, key) => {
                    if (formCheck[key].hasError) {
                        data[key] = formCheck[key].errorMessage;
                    }
                    return data;
                }, errors);

                setError((prevValue) => {
                    return {
                        ...prevValue,
                        moreOptionsError: formErrors
                    };
                });
                setMoreData(formValue);
                setFormData(formValue);
            }}
            style={{ margin: 0, marginBottom: 15, width: "100%" }}
            formError={errorObject}
        >
            <StyledFormStart>
                {isDefault && <div className="column">
                    <StyledContainerColumn>
                        <StyledContainerRow>
                            <StyledLabel compact display="block">
                                Postback URL
                                <Whisper
                                    placement="rightStart"
                                    trigger="hover"
                                    controlId="control-id-hover-enterable"
                                    speaker={parametersInfo}
                                    enterable
                                >
                                    <Icon icon="info" />
                                </Whisper>
                            </StyledLabel>
                            <StyledButton
                                withoutMargin
                                className="right"
                                onClick={() => {
                                    onPostbackTest();
                                }}
                                disabled={!formData.postback_url || Object.keys(errorObject).length}
                            >
                                Test Postback
                            </StyledButton>
                        </StyledContainerRow>
                        <Form.Control
                            name="postback_url"
                            accepter={CustomTextarea}
                            componentClass="textarea"
                            className="textarea"
                            disabled={disabled}
                            placeholder="Enter your postback url here"
                        />
                        {!service && <>
                            <StyledLabel compact display="block">
                                Postback method
                            </StyledLabel>
                            <Form.Control
                                accepter={SelectPicker}
                                data={postbackMethodData}
                                cleanable={false}
                                searchable={false}
                                labelKey="name"
                                valueKey="value"
                                name="postback_method"
                            />
                        </>}
                    </StyledContainerColumn>
                </div>}
                {service && <div className="column">
                    <StyledContainerRow>
                        <StyledLabel>Payout model</StyledLabel>
                        <Form.Control
                            accepter={SelectPicker}
                            data={payoutModelList}
                            name="payout_model"
                            labelKey="name"
                            valueKey="value"
                            disabled={disabled}
                            onChange={(value) => {
                                setShowRevenue(value === 2);
                                setPayoutModel(value);
                            }}
                            value={payoutModel}
                            defaultValue={1}
                            cleanable={false}
                            searchable={false}
                            placeholder="Select model"
                        />
                    </StyledContainerRow>
                </div>}
                {showRevenue && <div className="column">
                    <StyledContainerRow>
                        <StyledLabel>Percent from revenue</StyledLabel>
                        <Form.Control
                            accepter={InputNumber}
                            name="revenue_percent"
                            disabled={disabled}
                            placeholder="Enter your revenue"
                            step={0.1}
                            min={0}
                            max={100}
                        />
                    </StyledContainerRow>
                </div>}
            </StyledFormStart>
        </Form>
    );
};

export default MoreOptionsFormSection;
